import React from 'react';
import PropTypes from 'prop-types';
import {
  ExpansionPanel as MaterialExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  ExpansionPanelActions,
  Divider,
  Button,
} from '@material-ui/core';

import { ExpandMore } from '@material-ui/icons';
import ReactPlayer from 'react-player';
import { PanelSectionContainer } from './style';

const ExpansionPanel = ({ exercise, isAdmin, onDelete, onEdit, ...rest }) => {
  const Summary = () => {
    const handleSeriesAndReps = () => {
      if (exercise?.series > 0) {
        if (exercise?.reps > 0) {
          return `${exercise.series}x${exercise.reps}`;
        }
        return `${exercise.series}x`;
      }
      return '';
    };

    return (
      <PanelSectionContainer>
        <div className="bold">{exercise.name}</div>
        <div>{handleSeriesAndReps()}</div>
        <div>{exercise?.weight ? `${exercise.weight}kg` : '-'}</div>
      </PanelSectionContainer>
    );
  };

  const Details = () => (
    <PanelSectionContainer>
      {exercise.video && (
        <div>
          <ReactPlayer
            url={exercise.video}
            volume="0.1"
            config={{
              youtube: {
                playerVars: { showinfo: 0, controls: 2 },
              },
            }}
            height="100%"
            width="100%"
          />
        </div>
      )}

      <div>
        <b>Observações:</b>
        {` ${exercise.observations}`}
      </div>
    </PanelSectionContainer>
  );

  const Actions = () => (
    <>
      {isAdmin && (
        <Button
          size="small"
          style={{ color: 'red' }}
          onClick={() => onDelete(exercise.id)}
        >
          Deletar Exercício
        </Button>
      )}
      <Button size="small" onClick={onEdit}>
        {isAdmin ? 'Editar Dados' : 'Alterar Carga'}
      </Button>
    </>
  );

  return (
    <MaterialExpansionPanel {...rest}>
      <ExpansionPanelSummary expandIcon={<ExpandMore />}>
        <Summary />
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Details />
      </ExpansionPanelDetails>
      <Divider />
      <ExpansionPanelActions>
        <Actions />
      </ExpansionPanelActions>
    </MaterialExpansionPanel>
  );
};

export default ExpansionPanel;

ExpansionPanel.propTypes = {
  exercise: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

ExpansionPanel.defaultProps = {
  isAdmin: false,
};
